// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let UnknownStringValue = /* @__PURE__ */Primitive_exceptions.create("StockActivityReason.UnknownStringValue");

let values = [
  "LOSS",
  "THEFT",
  "DAMAGE",
  "TASTING",
  "OUTDATED_DLUO",
  "TRADE_IN_SUPPLIER",
  "SALE_BY_GLASS",
  "CORKY",
  "OTHER"
];

function toString(reason) {
  if (reason === "DAMAGE") {
    return "DAMAGE";
  } else if (reason === "OUTDATED_DLUO") {
    return "OUTDATED_DLUO";
  } else if (reason === "SALE_BY_GLASS") {
    return "SALE_BY_GLASS";
  } else if (reason === "THEFT") {
    return "THEFT";
  } else if (reason === "TASTING") {
    return "TASTING";
  } else if (reason === "LOSS") {
    return "LOSS";
  } else if (reason === "OTHER") {
    return "OTHER";
  } else if (reason === "TRADE_IN_SUPPLIER") {
    return "TRADE_IN_SUPPLIER";
  } else {
    return "CORKY";
  }
}

function toLabel(reason) {
  if (reason === "DAMAGE") {
    return I18n.t("Damage");
  } else if (reason === "OUTDATED_DLUO") {
    return I18n.t("Outdated DLUO");
  } else if (reason === "SALE_BY_GLASS") {
    return I18n.t("Sale by glass");
  } else if (reason === "THEFT") {
    return I18n.t("Theft");
  } else if (reason === "TASTING") {
    return I18n.t("Tasting");
  } else if (reason === "LOSS") {
    return I18n.t("Loss");
  } else if (reason === "OTHER") {
    return I18n.t("Other");
  } else if (reason === "TRADE_IN_SUPPLIER") {
    return I18n.t("Supplier trade in");
  } else {
    return I18n.t("Corky");
  }
}

function fromStringExn(value) {
  switch (value) {
    case "CORKY" :
      return "CORKY";
    case "DAMAGE" :
      return "DAMAGE";
    case "LOSS" :
      return "LOSS";
    case "OTHER" :
      return "OTHER";
    case "OUTDATED_DLUO" :
      return "OUTDATED_DLUO";
    case "SALE_BY_GLASS" :
      return "SALE_BY_GLASS";
    case "TASTING" :
      return "TASTING";
    case "THEFT" :
      return "THEFT";
    case "TRADE_IN_SUPPLIER" :
      return "TRADE_IN_SUPPLIER";
    default:
      throw {
        RE_EXN_ID: UnknownStringValue,
        Error: new Error()
      };
  }
}

export {
  UnknownStringValue,
  values,
  toString,
  toLabel,
  fromStringExn,
}
/* I18n Not a pure module */
